<box>
  <div class="d-flex align-items-center justify-content-center">
    <loading-spinner width="50" height="50"></loading-spinner>
  </div>
</box>